import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import * as OnlineContractActions from '../actions/online-contract.actions';
import { OnlineContractService } from '../../online-contract.service';
import { GlobalService } from 'app/global/global.service';
import { StorageAccessManager } from 'app/utils/storage-access-manager.service';


@Injectable()
export class OnlineContractEffects {
    constructor(
        private actions$: Actions,
        private onlineContractService: OnlineContractService,
        private globalService: GlobalService,
        private _storageAccessManager: StorageAccessManager
    ) { }

    getOnlineContract$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OnlineContractActions.getOnlineContract),
            switchMap(({ template_id, uuid }) =>
                this.onlineContractService.getTemplateDetail(template_id, uuid).pipe(
                    map((template) => OnlineContractActions.getOnlineContractSuccess(template)),
                    catchError((error) => of(OnlineContractActions.getOnlineContractFailure(error)))
                )
            )
        )
    );

    onlineContractFailures$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OnlineContractActions.getOnlineContractFailure, OnlineContractActions.signOnlineContractFailure),
            tap(({error}) => {
                this.globalService.toastrError(typeof error === 'string' ? error : error?.message);
            })
        ), { dispatch: false }
    );

    signOnlineContract$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OnlineContractActions.signOnlineContract),
            switchMap(({ data, template_id }) =>
                from(this._storageAccessManager.ensureStorageAccess()).pipe(
                    mergeMap(() =>
                        this.onlineContractService.signOnlineContract(data, template_id).pipe(
                            map(() => OnlineContractActions.signOnlineContractSuccess()),
                            catchError((error) =>
                                of(OnlineContractActions.signOnlineContractFailure(error))
                            )
                        )
                    )
                )
            )
        )
    );


    sendOnlineContractInvitation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OnlineContractActions.sendInvitation),
            switchMap(({data ,template_id }) =>
                this.onlineContractService.sendOnlineContractInvitation(data,template_id).pipe(
                    map(() => OnlineContractActions.sendInvitationSuccess()),
                    catchError((error) => of(OnlineContractActions.sendInvitationFailure(error)))
                )
            )
        )
    );

}
